/* Libraries */
import cn from 'classnames';
import { Grid } from 'ht-styleguide';

/* Components */
import PromoBlocks from '@components/Searchbar/Results/PromoBlocks';
import EmptyState from '@components/EmptyState';
import CategoryResults from '@components/Searchbar/Results/CategoryResults';
import ServiceResults from '@components/Searchbar/Results/ServiceResults';
import { DEFAULT_TEXTS } from '@components/Searchbar/constants';
import QuickLinks from '@components/Searchbar/Results/QuickLinks';

/* Styles */
import styles from './searchbar.module.scss';

/* Types */
type ResultsProps = {
  scoredResults?: $FixMe;
  productResults?: $FixMe;
  serviceResults?: $FixMe;
  searchTerm?: string;
  getItemProps: $FixMe;
  iconClick: $FixMe;
};
const Results = ({ serviceResults, productResults, scoredResults, searchTerm = '', getItemProps, iconClick, ...props }: ResultsProps) => {
  const rawResults = searchTerm ? scoredResults : [];
  const results =
    Array.isArray(rawResults) && rawResults.length ? (
      <>
        <ServiceResults serviceResults={serviceResults} searchTerm={searchTerm} getItemProps={getItemProps} iconClick={iconClick} />
      </>
    ) : (
      searchTerm && (
        <EmptyState
          className={cn('paddingY-medium', styles.noResults)}
          iconName="search"
          title={DEFAULT_TEXTS.EMPTY_STATE.title}
          additionalTitle={searchTerm}
          text={DEFAULT_TEXTS.EMPTY_STATE.text}
        />
      )
    );
  return (
    <Grid.FullWidth classes={styles.gridContainer} dataTestId="search-results-container">
      <Grid.Row classes={styles.autoComplete}>
        <Grid.Column sm={4} mdOffset={1} md={6} lg={12} classes={cn('marginBottom-medium', styles.column)}>
          {results}
          {!rawResults.length && <QuickLinks searchTerm={searchTerm} iconClick={iconClick} {...props} />}
        </Grid.Column>
        <Grid.Column sm={4} mdOffset={1} md={6} lg={12} classes={styles.blockColumn}>
          <PromoBlocks searchTerm={searchTerm} iconClick={iconClick} {...props} />
        </Grid.Column>
        {searchTerm && (
          <Grid.Column sm={4} mdOffset={1} md={6} lg={12} classes={styles.categoryWrapper}>
            {!scoredResults.length && <CategoryResults scoredResults={scoredResults} searchTerm={searchTerm} iconClick={iconClick} {...props} />}
          </Grid.Column>
        )}
      </Grid.Row>
    </Grid.FullWidth>
  );
};

export default Results;
